export default "__VITE_ASSET__BQH9AUj4__"